import React from 'react'
import { _ContentTitleWithMarginTop, Body2, H5, H6 } from './styles'
import { Stack } from '@mui/material'
import { ColorConf } from '@/config/color'
import { Box, styled } from '@mui/material'

const _DescriptionComingSoonWrapper = styled(Box)({
  backgroundColor: "#FAFAFA",
  borderRadius: 20,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  flexWrap: "wrap",
  padding: "24px 16px",
  borderBottom: "1px solid #EEEEEE",
  borderLeft: "1px solid #EEEEEE",
  borderRight: "1px solid #EEEEEE",
  borderTop: "0.5px solid #EEEEEE",
  boxShadow: "0px 2px 1px rgb(0 0 0 / 20%)",
  width: "100%",
  "@media (min-width: 600px)": {
    width: "320px",
    justifyContent: "center",
  }
});

const Prices = () => {
  return (
    <Stack
      direction="column"
      spacing={2}
      mt={4}
      p={3}
      gap={2}
      width="100%"
    >
      <_ContentTitleWithMarginTop sx={{ marginTop: 20 }}>
        ご利用料金
      </_ContentTitleWithMarginTop>
      <Stack
        sx={{
          flexDirection: "row",
          gap: 4,
          "@media (max-width: 600px)": {
            flexDirection: "column",
          }
        }}
      >
        <_DescriptionComingSoonWrapper>
          <H5>女性</H5>
          <H5 sx={{ position: "relative", color: ColorConf.HeroTertiaryText }}>
            完全無料
            <img src="/images/hero-line3.png" alt="line3" style={{ position: "absolute", top: 16, left: 0, width: "100%", height: 8 }} />
          </H5>
        </_DescriptionComingSoonWrapper>
        <_DescriptionComingSoonWrapper>
          <H5>男性</H5>
          <H5 sx={{ position: "relative", color: ColorConf.HeroTertiaryText }}>
            業界最安値の980円～
            <img src="/images/hero-line3.png" alt="line3" style={{ position: "absolute", top: 16, left: 0, width: "100%", height: 8 }} />
          </H5>
          <H6 color={ColorConf.HeroPrimaryColor} mt={1}>レコメンド・いいねをもらうまでは無料！</H6>
          <Body2 textAlign="center" mt={2}>
            いいねをくれた女性のプロフィールを
            <br />
            見るにはお金がかかります。
          </Body2>
        </_DescriptionComingSoonWrapper>
      </Stack>
    </Stack>
  )
}

export default Prices